module.exports = __webpack_public_path__ + "5e88f9ee236a8d6d67490f2bf9ac1731.svg";